import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { nav("/login", { replace: true }); return; }
    (async () => {
      try {
        await api.post("/auth/google/session", null, { headers: { "X-Session-ID": sessionId } });
        // Clear hash and go to dashboard
        window.history.replaceState({}, document.title, "/");
        window.location.href = "/";
      } catch (e) {
        toast.error("Sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [nav]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090B] text-zinc-300 text-sm font-mono">
      <div className="text-center">
        <div className="mb-3 h-5 w-5 mx-auto rounded-full border-2 border-blue-500 border-t-transparent animate-spin" />
        Finalising session…
      </div>
    </div>
  );
}
